module.exports = __webpack_public_path__ + "img/salsa_1720.9d5b6470.jpg";